import './App.css'
import Routing from "./routing/Routing";
const App = () => <Routing />;
export default App;
